export default function Footer() {
  return (
    <footer className="py-12 px-6 border-t border-[#2a2825] bg-[#0c0c0b] text-xs text-[#8a8276] font-mono-tag" data-testid="main-footer">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <span className="text-[#f4efe8] font-semibold">Borgo DiVino</span>
          <span>· Marino (RM), Castelli Romani</span>
        </div>
        <div>
          <span>Appartamento turistico 60 mq · Ideale per coppie e famiglie</span>
        </div>
      </div>
    </footer>
  );
}
